import http from '@/api/http';
import type { ShippingDirection } from '@/contexts/DirectionContext';
import type { CurrentOfferPrices } from '../interfaces/currentOfferPrices.interface';

export const currentOfferPricesApi = {
  async get(companyId?: number, direction?: ShippingDirection): Promise<CurrentOfferPrices | null> {
    const params: Record<string, string | number> = {};
    if (typeof companyId === 'number') params.companyId = companyId;
    if (direction) params.direction = direction;
    const response = await http.get('/dashboard/current-offer-prices', { params });
    return (response.data?.data as CurrentOfferPrices | null) ?? null;
  },
};
